module.exports = __webpack_public_path__ + "static/img/jkm.47a6340.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/record/jkm.png
// module id = jK/j
// module chunks = 1